'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var bowser = require('bowser');
var _process$platform, _process, _process2;
var platformName = (_process$platform = (_process = process) === null || _process === void 0 ? void 0 : _process.platform) !== null && _process$platform !== void 0 ? _process$platform : '';
if (typeof window !== 'undefined') {
  var _userAgent$os$name;
  var userAgent = bowser.parse(window.navigator.userAgent);
  platformName = (_userAgent$os$name = userAgent.os.name) !== null && _userAgent$os$name !== void 0 ? _userAgent$os$name : '';
}
var constPlatformName = platformName;
var osName = platformName;
var isMacOS = ['darwin', 'macOS'].includes(platformName);
var isWindows = ['win32', 'Windows'].includes(platformName);
var isLinux = ['linux', 'Linux'].includes(platformName);
var isDesktop = platformName === 'Electron' || ((_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.versions) === null || _process2 === void 0 ? void 0 : _process2.hasOwnProperty('electron'));
exports.default = constPlatformName;
exports.isDesktop = isDesktop;
exports.isLinux = isLinux;
exports.isMacOS = isMacOS;
exports.isWindows = isWindows;
exports.osName = osName;
